import React from "react";
import { View, StyleSheet, Text, Platform } from "react-native";

import Dialog from "../../common/dialog";
import AppTheme from "../../AppTheme";
import ManaButton from "../../common/ManaButton";
import CustomizeIcons from "../../common/icons/customize";
import appStyles from "../../../appStyles";

export default function CustomizeLifeDialog({
  markAsPersonal = () => {},
  onContinue = () => {},
  close = () => {},
}) {
  return (
    <Dialog.Container
      onClose={close}
      showCloseButton
      style={styles.container}
      headerStyle={{ margin: 0 }}
      contentStyle={{
        marginTop: 0,
        paddingTop: 8,
        paddingBottom: 12,
        minHeight: 360,
      }}
    >
      <View style={styles.header}>
        <Text style={styles.title}>Are you sure?</Text>
        <Text style={styles.description}>
          Customizing Health & Life Elements will help optimize all of your
          time. These are private only to you unless you decide to report them.
        </Text>
      </View>

      <View
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CustomizeIcons.TownIcon style={styles.image} />
      </View>

      <View style={[styles.buttons, { marginTop: "auto" }]}>
        <ManaButton
          style={[styles.button, appStyles.buttonShadow]}
          styleText={styles.buttonText}
          text="No, thanks"
          onPress={markAsPersonal}
        />

        <ManaButton
          isMainButton
          style={[styles.button, {flex: 1, marginLeft: 6 }]}
          styleText={styles.buttonText}
          text="Customize Life Elements"
          onPress={onContinue}
        />
      </View>
    </Dialog.Container>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    flex: 1,
  },
  close: {
    position: "absolute",
    top: 5,
    right: 5,
  },
  header: {
    justifyContent: "center",
    alignItems: "center",
  },
  title: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 20,
    lineHeight: 30,
    letterSpacing: 1,
    color: AppTheme.almostBlack,
  },
  description: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-Regular",
    }),
    fontWeight: "300",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.5,
    color: AppTheme.almostBlack,
    textAlign: "center",
  },
  buttons: {
    display: "flex",
    justifyContent: "space-evenly",
    alignItems: "center",
    flexDirection: "row",
    paddingHorizontal: 8,
  },
  button: {
    width: "auto",
    height: 32,
  },
  buttonText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
  },
  image: {
    marginVertical: 16,
  },
});
